// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__uOj07","tabListItem":"Tabs_tabListItem__-XWSI"};